import PolygonBase from './PolygonBase';
import shapeRoundRect from '../assets/icons/shapeRoundRect.svg';
import { svgToIcon } from '../utils/svg';
class ShapeRoundRect extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeRoundRect);
  }

  static pathString(r = 0.15) {
    return `
      M -${0.5 - r} -0.5
      L ${0.5 - r} -0.5
      R ${r} 0
      L 0.5 ${0.5 - r}
      R ${r} 1
      L -${0.5 - r} 0.5
      R ${r} 2
      L -0.5 -${0.5 - r}
      R ${r} 3
      Z
    `;
  }
}

export default ShapeRoundRect;
